export default __webpack_public_path__ + "static/media/zalozenie-pasieki-krok-po-kroku.dbb00284.png";